import format from "date-fns/format";
import { formatISODate, parseISODate } from "../date";
import { submit } from "../history-manager";

const DATE_FORMAT = "yyyy-MM-dd";

/**
 * Event filters
 */
export default function eventFilters(el, props) {
  submitFormOnCheckboxToggle(el, props);
  generateCalendar(el, props);
}

/**
 * Submit form when checkbox is toggled
 */
function submitFormOnCheckboxToggle(el, props) {
  const checkboxEl = el.querySelectorAll(props.checkboxEl);

  for (let i = 0; i < checkboxEl.length; ++i) {
    checkboxEl[i].addEventListener("change", function() {
      const cancelled = submit(el);
      if (!cancelled) {
        el.submit();
      }
    });
  }
}

/**
 * Generate calendar element and submit form when day is selected
 */
function generateCalendar(el, props) {
  const triggerEl = el.querySelector(props.calendarTriggerEl);
  const containerEl = el.querySelector(props.calendarContainerEl);
  const inputEl = el.querySelector(props.calendarInputEl);
  const maxDate = parseISODate(props.maxDate);
  const selectedDate = props.selectedDate
    ? parseISODate(props.selectedDate)
    : new Date();

  let picker;

  import("../vendor/pikaday").then(({ default: Pikaday }) => {
    picker = new Pikaday({
      bound: false,
      container: containerEl,
      defaultDate: selectedDate,
      setDefaultDate: selectedDate,
      field: triggerEl,
      firstDay: 1,
      maxDate: maxDate,
      onSelect: function(date) {
        inputEl.value = formatISODate(date);
        const cancelled = submit(el);
        if (!cancelled) {
          el.submit();
        }
      }
    });
  });

  return {
    destroy: () => {
      if (picker) {
        picker.destroy();
      }
    }
  };
}
